<template lang="html">
    <div v-html="text" class="wysiwyg centered-quote"></div>
</template>

<script>
  export default {
    name: 'SectionQuote',
    props: {
      text: {
        type: [Boolean, String],
        default: false
      }
    }
  }
</script>

<style lang="scss">
    .wysiwyg {
        em {
            font-family: 'HeyAugust';
        }
    }
    .centered-quote {
        text-align: center;
        margin: 4em 0;
    }

</style>
